import { on } from "delegated-events"
import { fetchForm } from "~/utils/fetch"
import { refresh } from "./refresh"

on("submit", ".js-hide-track-comment", async function(e) {
  e.preventDefault()

  const form = e.currentTarget as HTMLFormElement
  const sidebar = form.closest<HTMLElement>("[data-refresh-url]")
  const button = form.querySelector<HTMLButtonElement>("button[type='submit']")

  if (button) button.disabled = true

  try {
    await fetchForm(form)
    if (sidebar) await refresh(sidebar)
  } catch (error) {
    if (button) button.disabled = false
    throw error
  }
})
